module.exports = __webpack_public_path__ + "static/media/custom_publishing_1_C.84ce6417.png";